import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-param-reassign */
import produce from 'immer';
var experimentSettingsExcludeGenesUpdated = function experimentSettingsExcludeGenesUpdated(state, action) {
  var _state$info;
  var _action$payload = action.payload,
    experimentId = _action$payload.experimentId,
    excludeGenes = _action$payload.excludeGenes;
  var experimentSettingsExperimentId = state === null || state === void 0 || (_state$info = state.info) === null || _state$info === void 0 ? void 0 : _state$info.experimentId;
  var shouldUpdateExperimentSettings = experimentSettingsExperimentId === experimentId;
  if (!shouldUpdateExperimentSettings) {
    return state;
  }
  return produce(state, function (draft) {
    draft.info.excludeGenes = _objectSpread(_objectSpread({}, draft.info.excludeGenes || null), excludeGenes);
    return draft;
  });
};
export default experimentSettingsExcludeGenesUpdated;